import { connect } from 'react-redux';
import { saveCustomer } from 'src/routes/Checkout/store/domains/customer/slice';
import { getCitizenships } from 'src/routes/Checkout/store/selectors/data';
import {
  touristInfoForCustomerSelector,
  touristSelector,
} from 'src/store/tourists/selectors';
import { getIsMobile } from 'src/store/view/selectors';
import {
  customerInfoSelector,
  isCustomerInfoValidSelector,
  showFillerButtonSelector,
} from 'src/routes/Checkout/store/domains/customer/selectors';
import { touristsValidationSelector } from 'src/store/touristsValidation/selectors';
import { confirmTouristsAction } from 'src/routes/Checkout/store/actions/tourists';
import { Customer } from './Customer';

const mapStateToProps = (state) => {
  const tourist = touristSelector(state, 0);
  return {
    citizenships: getCitizenships(state),
    touristData: touristInfoForCustomerSelector(state, 0),
    isMobile: getIsMobile(state),
    showFillerButton: showFillerButtonSelector(state, tourist),
    initialValues: customerInfoSelector(state),
    mobileSubmitBtnDisabled:
      !touristsValidationSelector(state) || !isCustomerInfoValidSelector(state),
    customerInfo: customerInfoSelector(state),
  };
};

const mapDispatchToProps = {
  saveCustomerInfo: saveCustomer,
  onSubmit: confirmTouristsAction,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(Customer);
